import { isNil, toNumber } from 'lodash';

export const stringWithCommasToNumber = (string?: string) =>
  isNil(string) ? 0 : toNumber(string.replaceAll(',', ''));
